import ProcessingResource from "./ProcessingResource";
import {keys} from "../config/nameSpacesKeys";

export default class ProcessingResourceList {
  constructor(name, initialValue, namespace, mediaTypeNameSpace,
      formatNameSpace, processingResourceTypeNameSpace, isEditor = false) {
    this.namespace = namespace;
    this.name = name;
    this.isEditor = isEditor;
    this.mediaTypeNameSpace = mediaTypeNameSpace;
    this.formatNameSpace = formatNameSpace;
    this.processingResourceTypeNameSpace = processingResourceTypeNameSpace;
    this.processingResourceList = [];

    if (initialValue) {
      this.parseInputJSON(initialValue);
    } else {
      this.addValueObj();
    }
  }

  getNameSpace() {
    return this.namespace;
  }

  getObjList() {
    return this.processingResourceList;
  }

  setObjList(fprocessingResourceList) {
    this.processingResourceList = fprocessingResourceList;
  }

  removeValueObj(item, index) {
    if (index < 0 || index >= this.processingResourceList.length) {
      return;
    }
    this.processingResourceList.splice(index, 1);
  }

  addValueObj(obj) {
    const processingResource = new ProcessingResource(this.name, obj, this.namespace, this.mediaTypeNameSpace,
        this.formatNameSpace, this.processingResourceTypeNameSpace, keys.msLanguage,
        keys.languageCode, keys.languageVarietyName, keys.region, keys.script, keys.variant, this.isEditor);
    this.processingResourceList.push(processingResource);
    // console.log(this.processingResourceList);
  }

  parseInputJSON(inputJSON) {
    // const obj=inputJSON[this.namespace];
    const obj = inputJSON;
    // console.log(inputJSON, this.namespace);
    if (Array.isArray(obj)) {
      for (const entry of Object.entries(obj)) {
        const value = entry[1];
        this.addValueObj(value);
      }
    } else {
      this.addValueObj(obj);
    }
  }

  getExpandedFormatValue() {
    const expandedList = [];
    for (let index = 0; index < this.processingResourceList.length; index++) {
      const processingResourceItem = this.processingResourceList[index];
      expandedList.push(processingResourceItem.getExpandedFormatValue());
    }
    return expandedList;
  }

  isEmpty() {
    let condition = true;
    for (let index = 0; index < this.processingResourceList.length; index++) {
      const processingResourceItem = this.processingResourceList[index];
      condition = condition && processingResourceItem.isEmpty();
    }
    return condition;
  }
}
